import m from "../../geodata/es2015/barbadosHigh";
window.am4geodata_barbadosHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/barbadosHigh.js
// module id = null
// module chunks = 